import {
  GetSystemCodeKeysRequest,
  GetSystemCodeKeysRequestToJSON,
  HTTPQuery,
  SystemCodeKey,
  SystemCodeKeyFromJSON
} from '@/api'
import * as runtime from '../runtime'

/**
 * no description
 */
export class SystemCodeKeyApi extends runtime.BaseAPI {
  /**
   * システムコードキーの一覧を取得する
   * システムコードキー取得
   */
  async getSystemCodeKeys(
    request?: GetSystemCodeKeysRequest
  ): Promise<SystemCodeKey[]> {
    let queryParameters: HTTPQuery | undefined

    if (request) {
      queryParameters = Object.fromEntries(
        Object.entries(GetSystemCodeKeysRequestToJSON(request)).filter(
          value => value[1] !== undefined
        )
      ) as HTTPQuery
    }

    const response = await this.requestGet(`/system-code-keys`, queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemCodeKeyFromJSON)
    ).value()
  }

  /**
   * 入力条件により、システムコードキーを取得する
   * システムコードキー取得
   */
  async getSystemCodeKey(id: number): Promise<SystemCodeKey> {
    const response = await this.requestGet(`/system-code-keys/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      SystemCodeKeyFromJSON(jsonValue)
    ).value()
  }
}
